import { DataGrid } from 'devextreme-react';
import { Column, FilterRow, Lookup, Selection, Summary, TotalItem } from 'devextreme-react/data-grid';
import React, { useEffect } from 'react';
import useFormatMessage from '../../../../utils/useFormatMessage';

const GrupajList = ({
    dataSource,
    groupageRef
}) => {
    const { t } = useFormatMessage();
    useEffect(() => {
        if (groupageRef.current) {
            // groupageRef.current.instance.clearSelection();
        }
    }, [dataSource]);

    // Benzersiz "from_warehouse_name" değerlerini al
    // const uniqueWarehouses = dataSource ? [...new Set(dataSource.map(item => item.from_warehouse_name))].filter(Boolean) : [];
    // const warehouseData = uniqueWarehouses.map(name => ({ id: name, name: name }));

    const operationDescriptions = {
        "between": t("between"),
        "contains": t("contains"),
        "endswith": t("endswith"),
        "equal": t("equal"),
        "greaterThan": t("greaterThan"),
        "greaterThanOrEqual": t("greaterThanOrEqual"),
        "lessThan": t("lessThan"),
        "lessThanOrEqual": t("lessThanOrEqual"),
        "notContains": t("notContains"),
        "notEqual": t("notEqual"),
        "startsWith": t("startswith"),
        "endsWith": t("endsWith")
    };

    const statusLookup = [
        { id: 'ONAYLANDI', name: 'Onaylandı' },
        { id: 'TIR_ESLENDI', name: 'Tır Eşlendi' },
        { id: 'KAPI_CIKIS', name: 'Kapı Çıkış' },
        { id: 'EKSIK_KAPI_CIKIS', name: 'Eksik Çıkış' },
        { id: 'APPROVED-CANCELED', name: 'Onay İptal' },
        { id: 'ONAY_BEKLIYOR', name: '-' }
    ];

    return (
        <div className='mt-1 card'>
            <DataGrid
                dataSource={dataSource}
                id='gridContainer-custom'
                className='datagrid-color'
                ref={groupageRef}
                showBorders={true}
                showRowLines={true}
                showColumnLines={true}
                noDataText='Veri Yok'
                allowColumnResizing={true}
                // filterSyncEnabled={true}
                style={{
                    minHeight: "500px",
                }}
                onCellPrepared={(e) => {
                    if (e.rowType === "data" && e.column.dataField === "groupage_no" && e.data.vehicles.some(v => v.priority !== null)) {
                        // priority en büyük kaç?
                        let maxPriority = Math.max(...e.data.vehicles.map(v => v.priority));
                        if (maxPriority === 1 || maxPriority === 2) {
                            e.cellElement.style.backgroundColor = "pink";
                            e.cellElement.style.color = "black";
                            e.cellElement.style.fontWeight = "bold";
                        }
                        else {
                            e.cellElement.style.backgroundColor = "red";
                            e.cellElement.style.color = "#e4e4e4";
                            e.cellElement.style.fontWeight = "bold";
                        }
                    }
                }}
            >
                <FilterRow visible={true}
                    operationDescriptions={operationDescriptions}
                    showAllText='(Tümü)'
                // applyFilter="auto" 
                />
                <Selection mode='multiple' />
                <Column dataField="groupage_no" caption="Grupaj No" alignment='center' selectedFilterOperation='contains' width={"130"} />
                <Column caption="Nereden" dataField="from_warehouse_name" alignment='center' selectedFilterOperation='contains' minWidth={"150"}>
                    {/* <Lookup
                        dataSource={warehouseData}
                        valueExpr="id"
                        displayExpr="name"
                    /> */}
                </Column>
                <Column caption="Nereye" dataField="to_warehouse_name" alignment='center' selectedFilterOperation='contains' width={"200"} />
                <Column caption='Grupaj Onay Tarihi' dataField='approved_date' alignment='center' selectedFilterOperation='contains' dataType='datetime' format={"dd.MM.yyyy HH:mm"} width={"130"} />
                <Column caption='Yazdırma Tarihi' dataField='printed_date' alignment='center' selectedFilterOperation='contains' dataType='datetime' format={"dd.MM.yyyy HH:mm"} width={"130"} />
                <Column caption='Kapı Çıkış Tarihi' dataField='door_exit_date' alignment='center' selectedFilterOperation='contains' dataType='datetime' format={"dd.MM.yyyy HH:mm"} width={"130"}
                    calculateDisplayValue={(rowData) => {
                        const doorExitDates = rowData.vehicles
                            .map(vehicle => vehicle.door_exit_date)
                            .filter(date => date !== null && date !== undefined);

                        if (doorExitDates.length > 0) {
                            const dates = doorExitDates.map(date => new Date(date));
                            const maxDate = new Date(Math.max(...dates));
                            return maxDate;
                        }
                        return null;
                    }}
                    calculateCellValue={(rowData) => {
                        const doorExitDates = rowData.vehicles
                            .map(vehicle => vehicle.door_exit_date)
                            .filter(date => date !== null && date !== undefined);

                        if (doorExitDates.length > 0) {
                            const dates = doorExitDates.map(date => new Date(date));
                            const maxDate = new Date(Math.max(...dates));
                            return maxDate;
                        }
                        return null;
                    }}
                />
                <Column caption='Tır Plaka' dataField='truck_info.plate_number' alignment='center' selectedFilterOperation='contains' width={90} />
                <Column caption='Şöför' dataField='truck_info.driver_name' alignment='center' selectedFilterOperation='contains' width={"130"} />
                <Column caption='Taşıyıcı Firma' dataField='truck_info.subcontractor_name' alignment='center' selectedFilterOperation='contains' width={95} />
                <Column caption='Grupaj Statü' dataField='status' alignment='center' selectedFilterOperation='=' width={135}
                    calculateDisplayValue={(rowData) => {
                        const doorExitCount = rowData.vehicles.filter(vehicle => vehicle.door_exit_date).length;
                        if (doorExitCount === rowData.vehicles.length) return `Kapı Çıkış (${doorExitCount}/${rowData.vehicles.length})`;
                        if (doorExitCount >= 1) return `Eksik Çıkış  (${doorExitCount}/${rowData.vehicles.length})`;
                        if (rowData.status === "APPROVED-CANCELED") return 'Onay İptal';
                        else if (rowData.truck_info) return 'Tır Eşlendi';
                        else if (rowData.approved_date) return 'Onaylandı';
                        else return 'Onay Bekliyor';
                    }}
                    calculateCellValue={(rowData) => {
                        const doorExitCount = rowData.vehicles.filter(vehicle => vehicle.door_exit_date).length;
                        if (doorExitCount === rowData.vehicles.length) return 'KAPI_CIKIS';
                        if (doorExitCount >= 1) return 'EKSIK_KAPI_CIKIS';
                        if (rowData.status === "APPROVED-CANCELED") return 'APPROVED-CANCELED';
                        else if (rowData.truck_info) return 'TIR_ESLENDI';
                        else if (rowData.approved_date) return 'ONAYLANDI';
                        else return 'ONAY_BEKLIYOR';
                    }}
                >
                    <Lookup
                        dataSource={statusLookup}
                        valueExpr="id"
                        displayExpr="name"
                    // searchEnabled={false}
                    />
                </Column>
                <Column caption='Adet' dataField='vehicle_count' alignment='center' selectedFilterOperation='contains'
                    width={50}
                />

                <Summary>
                    <TotalItem
                        column="groupage_no"
                        summaryType="count"
                        displayFormat="Toplam: {0}"
                    />
                </Summary>

            </DataGrid>
        </div>
    )
}

export default GrupajList